import Fountain from "./main";

if (typeof(module.exports) !== 'undefined') {
    module.exports = Fountain;
}
(
    function () {
        const event = new CustomEvent('Fountain.Init', {'detail': {'class': Fountain}});
        window.dispatchEvent(event);
    }
)();